<template>
    <div id="apps">
        <transition name="slide" mode="out-in">                        
            <router-view @authenticated="setAuthenticated" />
        </transition>
                    
               
    </div>
</template>


<script>
    export default {
        name: 'Apps',
        data() {
            return {
                authenticated: false,
                get tokenF() {
                  return localStorage.getItem('token') || 0 ;
                },
                //hostname: window.location.origin,
                //hostname: 'http://page19.test',
                //hostname: 'https://test.samenfris.nl'
            }
        },
        mounted() {
            if(!this.authenticated) {
                this.$router.replace({ name: "login" });
                //console.log(this.tokenF);
            }
            if (this.tokenF==0) {
                this.$router.replace({ name: "login" });
            }
            
        },
        methods: {
            setAuthenticated(status) {
                this.authenticated = status;
            }
        }
    }
</script>

<style lang="scss">

@use "@/scss/teacher.scss" as *;
.leveled{
    z-index: 10;
    position: relative;
}
.appheader,.head-name{
    z-index: 100;
    position: relative;
}
    .slide-leave-active {
        transition: opacity .5s ease;
        opacity: 0;
        animation: slide-out .5s ease-out forwards;
    }

    .slide-leave {
        opacity: 1;
        transform: translateX(0);
    }

    .slide-enter-active {
        animation: slide-in .7s ease-out forwards;
    }

    @keyframes slide-out {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(500px);
        }
    }

    @keyframes slide-in {
         0% {
            transform: translateY(-250px);
        }
        100% {
            transform: translateY(0);
        }
    }



</style>
